export default __webpack_public_path__ + "static/epilogue-a0520e83928d97f6d6e26c515c06bc94.svg";